import React, {useContext, createContext} from "react";
import useSWR from "swr";
import {useUserContext} from './UserContext';
import axiosInstance from '../utils/axiosInstance';
import {logoutUser} from "../utils/authUtil";


const OrderContextDelete = createContext(null);


const fetcher = async (args) => {
    try {
        // Destructure the args array to get url and organization_id
        const [url, organization_id] = args;
        const response = await axiosInstance.get(url, {
            params: {
                organization_id,
            },
        });
        return response.data;
    }
    catch (error) {

        console.error("An error occurred while fetching data:", error);
        console.log(error.response.status)
        if(error.response.status === 401)
        {
            // logoutUser()
            console.log('will log out')}
        throw error; // Rethrow the error to be caught by the useSWR hook
    }}


export const OrderProvider = ({children}) => {
    const {user} = useUserContext();
    const organization_id = user ? user.organization_id : null;
    const {data: orders, error,mutate} = useSWR(
        organization_id ? [`/orders`, organization_id] : null,
        fetcher, {
            dedupingInterval: 10000,
            revalidateOnFocus: false,
        }
    );

    if (error) {
        console.error("An error occurred:", error);
    }

    return (
        <OrderContextDelete.Provider value={{orders, error,mutate}}>
            {children}
        </OrderContextDelete.Provider>
    );
};


export const useOrders = () => {
    const context = useContext(OrderContextDelete);
    if (context === null) {
        throw new Error("useOrders must be used within an OrderProvider");
    }
    return context;
};
